import { render, staticRenderFns } from "./ModalBlackUser.vue?vue&type=template&id=f1c147da&"
import script from "./ModalBlackUser.vue?vue&type=script&lang=js&"
export * from "./ModalBlackUser.vue?vue&type=script&lang=js&"
import style0 from "./ModalBlackUser.vue?vue&type=style&index=0&id=f1c147da&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports